export const getElementWidth = (element: HTMLElement): number =>
  element.getBoundingClientRect().width;

export const getElementHeight = (element: HTMLElement): number =>
  element.getBoundingClientRect().height;
